var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-tab"},[_c('div',{staticClass:"cs-card"},[_c('span',{staticClass:"material-icons-outlined cs-icon"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"cs-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"cs-chip"},[_vm._v("Em breve")]),_c('div',{staticClass:"cs-desc"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }